import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect } from "react";
import { useQueryLoader } from "react-relay";
import { ThemeQuery } from "../Shared/components/BrandingProvider/ThemeQuery";
import { useEnvironment } from "../Shared/components/EnvironmentProvider/EnvironmentProvider";
import Loading from "../Shared/components/loading";
const initState = {
    themeQueryReference: null,
    loadThemeQuery: () => { },
    disposeThemeQuery: () => { },
};
export const PreloadedQueriesContext = createContext(initState);
// A provider component that triggers the preloading of queries and provides the preloaded queries to its children.
export const PreloadedQueriesProvider = ({ children }) => {
    const { environment } = useEnvironment();
    // Preload the theme.
    const [themeQueryReference, loadThemeQuery, disposeThemeQuery] = useQueryLoader(ThemeQuery);
    // Only load the theme query once, and only when environment is ready
    useEffect(() => {
        if (!themeQueryReference) {
            loadThemeQuery({});
        }
        return () => {
            disposeThemeQuery();
        };
    }, [loadThemeQuery, disposeThemeQuery]);
    if (!themeQueryReference) {
        return _jsx(Loading, { text: environment === "localhost" ? "Preloaded Queries Provider..." : undefined });
    }
    return (_jsx(PreloadedQueriesContext.Provider, Object.assign({ value: { themeQueryReference, loadThemeQuery, disposeThemeQuery } }, { children: children })));
};
